import { makeStyles } from "@material-ui/core";
import {
	DEFAULT_BOX_SHADOW,
	PRIMARY_BACKGROUND,
	instance2,
} from "App/constants";
import { today } from "App/utils/helpers";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGetKunjungan = "/satu-sehat/condition/asha-registrasi";

export const STYLE_MASTER_SATU_BUNDLE = makeStyles({
	root: {
		width: "auto",
	},
	paper: {
		width: "100%",
		margin: "0",
		padding: "1rem 1.5rem",
		backgroundColor: PRIMARY_BACKGROUND,
		boxShadow: DEFAULT_BOX_SHADOW,
	},
	table: {
		width: "100%",
		margin: "0 auto",
		overflow: "auto",
	},
});

export const RESET_STATE_KUNJUNGAN = {
	id_kunjungan: "",
	nama_pasien: "",
	no_rm: "",
	id_ihs: "",
	instalasi: "",
	id_dokter: "",
	nama_dokter: "",
	participant: "",
	id_spesialist: "",
	dokter: "",
	periode_mulai: "",
	periode_selesai: "",
	asmed: "",
	status_history_arrive: "",
	status_history_inprogress: "",
	status_history_finish: "",
	id_ases_medis: "",
	id_ases_perawat: "",
	poli_code: "",
	nama_poliklinik: "",
	id_poliklinik: "",
	id_location: "",
	kode: "",
	name: "",
	description: "",
	status: "",
	tglAwal: today(),
	tglAkhir: today(),
	pages: 1,
	limit: 10,
};

export const headCellsKunjungan = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: false,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "id_kunjungan",
		disablePadding: false,
		label: "ID KUNJUNGAN",
		align: "center",
		minWidth: "20px",
	},
	{
		id: "nama_pasien",
		disablePadding: false,
		label: "NAMA PASIEN",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "no_rm",
		disablePadding: false,
		label: "NO. RM",
		align: "center",
		minWidth: "120px",
	},
	{
		id: "instalasi",
		disablePadding: false,
		label: "INSTALASI",
		align: "center",
		minWidth: "150px",
	},
	{
		id: "nama_dokter",
		disablePadding: false,
		label: "DOKTER",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "dokter",
		disablePadding: false,
		label: "SPESIALIS",
		align: "center",
		minWidth: "100px",
	},
];

export const getKunjungan = async (formFilter, pages, limit) => {
	try {
		const api = await instance2.get(
			`${urlGetKunjungan}?tglAwal=${startOfDay(
				formFilter.tglAwal
			)}&tglAkhir=${lastOfDay(
				formFilter.tglAkhir
			)}&limit=${limit}&pages=${pages}&id_kunjungan=${
				formFilter.id_kunjungan
			}&id_dokter=${formFilter.id_dokter}&no_rm=${
				formFilter.no_rm
			}&nama_pasien=${formFilter.nama_pasien}`
		);
		const res = api.data;
		return {
			state: true,
			message: res.message,
			data: res.data,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};
